/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Why_Openrift_TitleInputs */



/**
* | output |
* | --- |
* | "Why OpenRift?" |
*
* @param {Help_Article_Why_Openrift_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_why_openrift_title = /** @type {((inputs?: Help_Article_Why_Openrift_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Why_Openrift_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warum OpenRift?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pourquoi OpenRift ?")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("为什么选择 OpenRift？")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("為什麼是 OpenRift？")
	if (locale === "ko") return /** @type {LocalizedString} */ ("OpenRift를 쓰는 이유")
	return /** @type {LocalizedString} */ ("Why OpenRift?")
});